/* ===================================================================
   UUTISKIRJE-POPUP  →  sections/newsletter-popup.liquid
   - Ajastus (viive) + exit intent (desktop)
   - Ei näytetä uudelleen: tilaaja = pysyvästi, suljettu = N päivää
   - Natiivi lähetys (Shopifyn hCaptcha vaatii), paluu avaa kiitostilan
   - Theme Editor: aukeaa kun osio valitaan
   =================================================================== */
(function () {
  if (window.__nlpInit) return;
  window.__nlpInit = true;

  var KEY_SUB = 'nlp:subscribed';
  var KEY_SNOOZE = 'nlp:snooze-until';
  var FORM_HASH = '#NewsletterPopupForm';

  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  function isSuppressed() {
    if (read(KEY_SUB)) return true;
    var until = parseInt(read(KEY_SNOOZE) || '0', 10);
    return until > Date.now();
  }

  var dialog, timer, shown = false;

  function find() { return document.querySelector('[data-nlp]'); }

  function open() {
    dialog = find();
    if (!dialog || dialog.open) return;
    // Älä keskeytä kirjoittamista (haku, lomake) — yritä myöhemmin
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !dialog.contains(a)) {
      timer = setTimeout(open, 5000);
      return;
    }
    shown = true;
    dialog.classList.remove('is-closing');
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.documentElement.classList.add('nlp-lock');
  }

  function close(opts) {
    dialog = find();
    if (!dialog || !dialog.open) return;
    var silent = (opts && opts.silent) || (window.Shopify && window.Shopify.designMode);
    if (!silent && !read(KEY_SUB)) {
      var days = parseInt(dialog.dataset.snoozeDays || '7', 10);
      store(KEY_SNOOZE, String(Date.now() + days * 864e5));
    }
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      dialog.classList.remove('is-closing');
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.classList.remove('nlp-lock');
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return finish();
    dialog.classList.add('is-closing');
    dialog.addEventListener('animationend', function h(e) {
      if (e.target !== dialog) return;
      dialog.removeEventListener('animationend', h);
      finish();
    });
    setTimeout(finish, 350);
  }

  /* --- tapahtumat (delegointi: kestää Theme Editorin uudelleenlatauksen) --- */
  document.addEventListener('click', function (e) {
    var d = find();
    if (!d || !d.open) return;
    if (e.target === d) return close();               // backdrop
    if (e.target.closest('[data-nlp-close]') && d.contains(e.target)) close();
  });

  document.addEventListener('cancel', function (e) {  // Esc
    if (e.target && e.target.matches && e.target.matches('[data-nlp]')) {
      e.preventDefault();
      close();
    }
  }, true);

  document.addEventListener('input', function (e) {
    if (!e.target.classList || !e.target.classList.contains('nlp__input')) return;
    e.target.removeAttribute('aria-invalid');
    var err = find() && find().querySelector('[data-nlp-error]');
    if (err) err.hidden = true;
  });

  // Natiivi lähetys: Shopifyn hCaptcha lisää tokenin submit-tapahtumassa.
  // EI preventDefaultia / fetchiä — ohittaisi captchan ("Invalid CAPTCHA token").
  // Paluu: /?customer_posted=true#NewsletterPopupForm → popup aukeaa kiitos-/virhetilassa.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('nlp__form')) return;
    var btn = form.querySelector('.nlp__btn[type="submit"]');
    if (btn) btn.classList.add('is-loading');
  });

  window.addEventListener('pageshow', function (e) {   // bfcache-paluu: nollaa spinneri
    if (!e.persisted) return;
    var btn = document.querySelector('.nlp__form .nlp__btn.is-loading');
    if (btn) btn.classList.remove('is-loading');
  });

  /* --- käynnistys --- */
  function init() {
    dialog = find();
    if (!dialog) return;

    var designMode = window.Shopify && window.Shopify.designMode;
    var params = new URLSearchParams(location.search);
    var posted = params.get('customer_posted') === 'true';

    // Palattu natiivista lähetyksestä
    if (posted) store(KEY_SUB, '1');
    if (location.hash === FORM_HASH) {
      if (!designMode) open();
      if (history.replaceState) {
        params.delete('customer_posted');
        var q = params.toString();
        history.replaceState(null, '', location.pathname + (q ? '?' + q : ''));
      }
      return;
    }

    if (designMode || isSuppressed()) return;

    var delay = parseInt(dialog.dataset.delay || '10', 10) * 1000;
    timer = setTimeout(function () { if (!shown && !isSuppressed()) open(); }, delay);

    if (dialog.dataset.exitIntent === 'true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      setTimeout(function () {
        document.addEventListener('mouseout', function onOut(e) {
          if (e.relatedTarget || e.clientY > 0) return;
          document.removeEventListener('mouseout', onOut);
          if (!shown && !isSuppressed()) { clearTimeout(timer); open(); }
        });
      }, 3000);
    }
  }

  /* --- Theme Editor --- */
  document.addEventListener('shopify:section:select', function (e) {
    var d = find();
    if (d && d.dataset.sectionId === e.detail.sectionId) open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var d = find();
    if (d && d.dataset.sectionId === e.detail.sectionId) close({ silent: true });
  });
  document.addEventListener('shopify:section:load', function (e) {
    var d = find();
    if (d && d.dataset.sectionId === e.detail.sectionId) {
      document.documentElement.classList.remove('nlp-lock');
      open();
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();